/** @see https://nerdwallet.atlassian.net/browse/APEX-1703 for context */
export const isCredibleInterstitialArtEligible = (req) => {
  return req.query.interstitial_art === 'credible';
};
